module.exports = __webpack_public_path__ + "img/light-icon-logo.e8f97436.svg";